import { ExitSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import { Divider } from '@snack-uikit/divider';

import { LoadingOverlay } from '@/components/static';
import { Fn } from '@/types/common';

import s from './styles.module.scss';
import { FullUserInitials, ProfileBadge } from './utils';

export function DropDownContent({
  handleLogout,
  isLoadingLogout,
}: {
  isLoadingLogout: boolean;
  handleLogout: Fn<unknown, Promise<void | null>>;
}) {
  return (
    <LoadingOverlay isLoading={isLoadingLogout}>
      <div className={s.auth_dropdown_content}>
        <div className={s.user_initials_wrapper}>
          <ProfileBadge />
          <FullUserInitials />
        </div>
        <Divider />
        <ButtonFunction iconPosition='before' label='Выйти из аккаунта' icon={<ExitSVG />} onClick={handleLogout} />
      </div>
    </LoadingOverlay>
  );
}
